(function () {
  'use strict';

  function initInview(root) {
    if (root.getAttribute('data-lp-assurance-inview-ready') === 'true') return;
    root.setAttribute('data-lp-assurance-inview-ready', 'true');

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      root.classList.add('is-inview');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-inview');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
    );

    observer.observe(root);
  }

  function initDialog(root) {
    if (root.getAttribute('data-lp-assurance-dialog-ready') === 'true') return;

    var dialog = root.querySelector('[data-lp-assurance-dialog]');
    if (!dialog) return;

    root.setAttribute('data-lp-assurance-dialog-ready', 'true');

    if (dialog.parentNode !== document.body) {
      document.body.appendChild(dialog);
    }

    var titleEl = dialog.querySelector('[data-lp-assurance-dialog-title]');
    var bodyEl = dialog.querySelector('[data-lp-assurance-dialog-body]');
    var actionsEl = dialog.querySelector('[data-lp-assurance-dialog-actions]');
    var closeEls = dialog.querySelectorAll('[data-lp-assurance-dialog-close]');
    var triggers = root.querySelectorAll('[data-lp-assurance-dialog-trigger]');
    var panel = dialog.querySelector('[data-lp-assurance-dialog-panel]');
    var lastFocus = null;
    var dialogId = dialog.id;

    function lockPageScroll() {
      document.documentElement.classList.add('lp-assurance-dialog-open');
      document.body.classList.add('lp-assurance-dialog-open');
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('lp-assurance-dialog-open');
      document.body.classList.remove('lp-assurance-dialog-open');
    }

    function setActionsHtml(html) {
      if (!actionsEl) return;
      actionsEl.innerHTML = html;
    }

    function closeDialog() {
      dialog.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
      unlockPageScroll();
      if (lastFocus && typeof lastFocus.blur === 'function') {
        lastFocus.blur();
      }
      lastFocus = null;
    }

    function openDialog(trigger) {
      if (!titleEl || !bodyEl) return;

      lastFocus = trigger;

      var title = trigger.getAttribute('data-dialog-title') || '';
      var body = trigger.getAttribute('data-dialog-body') || '';
      var link = trigger.getAttribute('data-dialog-link') || '';
      var linkLabel = trigger.getAttribute('data-dialog-link-label') || 'Learn more';
      var link2 = trigger.getAttribute('data-dialog-link-2') || '';
      var link2Label = trigger.getAttribute('data-dialog-link-2-label') || '';
      var newTab = trigger.getAttribute('data-dialog-link-new-tab') === 'true';
      var newTab2 = trigger.getAttribute('data-dialog-link-2-new-tab') === 'true';

      titleEl.textContent = title;
      bodyEl.textContent = body;

      setActionsHtml('');
      if (actionsEl) actionsEl.hidden = true;

      if (link) {
        var a1 = document.createElement('a');
        a1.className = 'lp-assurance__dialog-cta';
        a1.href = link;
        if (newTab) {
          a1.target = '_blank';
          a1.rel = 'noopener noreferrer';
        }
        a1.textContent = linkLabel + ' ›';
        actionsEl.appendChild(a1);
        actionsEl.hidden = false;
      }
      if (link2) {
        var a2 = document.createElement('a');
        a2.className = 'lp-assurance__dialog-cta';
        a2.href = link2;
        if (newTab2) {
          a2.target = '_blank';
          a2.rel = 'noopener noreferrer';
        }
        a2.textContent = link2Label + ' ›';
        actionsEl.appendChild(a2);
        actionsEl.hidden = false;
      }

      lockPageScroll();

      dialog.hidden = false;
      dialog.setAttribute('aria-hidden', 'false');

      var closeBtn = dialog.querySelector('.lp-assurance__dialog-close');
      if (closeBtn) {
        try {
          closeBtn.focus({ preventScroll: true });
        } catch (err) {
          closeBtn.focus();
        }
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openDialog(trigger);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.stopPropagation();
        closeDialog();
      });
    });

    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (panel && panel.contains(event.target)) return;
      closeDialog();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDialog();
      }
    });

    if (dialogId) {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-controls', dialogId);
        trigger.setAttribute('aria-haspopup', 'dialog');
      });
    }
  }

  function initAssurance(root) {
    if (!root || root.getAttribute('data-lp-assurance-ready') === 'true') return;
    root.setAttribute('data-lp-assurance-ready', 'true');
    initInview(root);
    initDialog(root);
  }

  function boot(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    if (ctx.matches && ctx.matches('[data-lp-assurance]')) {
      initAssurance(ctx);
    }
    var nodes = ctx.querySelectorAll ? ctx.querySelectorAll('[data-lp-assurance]') : [];
    for (var i = 0; i < nodes.length; i += 1) {
      initAssurance(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
